/* ===================================================
   JAW Theme — main.js
   - Countdown
   - Varianten-Auswahl + Variant-Swapping
   - AJAX Add-to-Cart
   - AJAX Mengen-Änderung (Cart)
   - Bildgalerie
   =================================================== */

window.JAW = (function() {

  /* ---------- COUNTDOWN ---------- */
  var countdownEnd = new Date('2026-05-15T23:59:59');
  var cdTimer;

  function padZero(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function tickCountdown() {
    var now = new Date();
    var diff = Math.max(0, countdownEnd - now);

    var el = {
      d: document.getElementById('cd-d'),
      h: document.getElementById('cd-h'),
      m: document.getElementById('cd-m'),
      s: document.getElementById('cd-s')
    };

    if (!el.d) return; // Element nicht vorhanden

    el.d.textContent = padZero(Math.floor(diff / 86400000));
    el.h.textContent = padZero(Math.floor((diff % 86400000) / 3600000));
    el.m.textContent = padZero(Math.floor((diff % 3600000) / 60000));
    el.s.textContent = padZero(Math.floor((diff % 60000) / 1000));

    if (diff === 0) clearInterval(cdTimer);
  }

  tickCountdown();
  cdTimer = setInterval(tickCountdown, 1000);


  /* ---------- VARIANTEN-AUSWAHL ---------- */
  function selectOption(btn) {
    // Aktiv-Status setzen
    var group = btn.parentElement;
    group.querySelectorAll('.sz').forEach(function(b) {
      b.classList.remove('on');
    });
    btn.classList.add('on');

    // Passende Variante finden
    findAndSetVariant();
  }

  function findAndSetVariant() {
    var variants = window.productVariants;
    if (!variants || !variants.length) return;

    // Alle aktuell gewählten Optionswerte sammeln
    var selected = [];
    document.querySelectorAll('.sizes').forEach(function(group) {
      var active = group.querySelector('.sz.on');
      selected.push(active ? active.dataset.value : null);
    });

    // Variante suchen die zu allen gewählten Werten passt
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var fits = selected.every(function(val, idx) {
        return val === null || opts[idx] === val;
      });
      if (fits) { match = v; break; }
    }

    if (!match) return;

    // Hidden Input aktualisieren
    var input = document.getElementById('variant-id');
    if (input) input.value = match.id;

    // Preis aktualisieren
    var priceEl = document.getElementById('variant-price');
    if (priceEl) priceEl.textContent = formatMoney(match.price);

    // Button-Status aktualisieren
    var btn = document.getElementById('add-to-cart-btn');
    if (btn) {
      if (match.available) {
        btn.disabled = false;
        btn.classList.remove('order-btn--sold-out');
        btn.textContent = 'Jetzt sichern — Pre-Order · ' + formatMoney(match.price);
      } else {
        btn.disabled = true;
        btn.classList.add('order-btn--sold-out');
        btn.textContent = 'Ausverkauft';
      }
    }
  }

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + '\u00a0€';
  }


  /* ---------- AJAX ADD TO CART ---------- */
  var form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = document.getElementById('add-to-cart-btn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt…';
      }

      var variantId = document.getElementById('variant-id');
      if (!variantId || !variantId.value) {
        if (btn) { btn.disabled = false; btn.textContent = 'Jetzt sichern'; }
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId.value, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status) {
          // Fehler von Shopify
          alert(item.description || 'Fehler beim Hinzufügen.');
          if (btn) { btn.disabled = false; btn.textContent = 'Jetzt sichern'; }
          return;
        }
        // Warenkorb-Anzahl aktualisieren
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        if (!cart) return;
        // Nav-Counter
        var counter = document.querySelector('.cart-count');
        if (counter) counter.textContent = '(' + cart.item_count + ')';

        // Toast anzeigen
        showToast();

        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Jetzt sichern — Pre-Order · ' + formatMoney(cart.items[0] ? cart.items[0].price : 0);
        }
      })
      .catch(function(err) {
        console.error('[JAW] Cart add error:', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Jetzt sichern'; }
      });
    });
  }


  /* ---------- AJAX MENGEN-ÄNDERUNG (CART) ---------- */
  function changeQty(lineKey, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Seite neu laden damit Summen stimmen
      window.location.reload();
    })
    .catch(function(err) {
      console.error('[JAW] Cart change error:', err);
      window.location.reload();
    });
  }


  /* ---------- TOAST ---------- */
  function showToast() {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.removeAttribute('aria-hidden');
    toast.style.display = 'flex';
    setTimeout(function() {
      toast.setAttribute('aria-hidden', 'true');
      toast.style.display = '';
    }, 4000);
  }


  /* ---------- BILDGALERIE ---------- */
  document.querySelectorAll('.thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.getElementById('main-product-image');
      if (main && thumb.dataset.full) main.src = thumb.dataset.full;
      document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });


  /* ---------- PUBLIC API ---------- */
  return {
    selectOption: selectOption,
    changeQty: changeQty,
    formatMoney: formatMoney
  };

})();

/* ===== LIVE SOLD COUNTER ===== */
(function() {
  var el = document.getElementById('btm-sold-num');
  if (!el) return;

  var TOTAL = 350;
  var OFFSET = 80;
  var REAL_ORDERS = 261;
  var BASE = REAL_ORDERS + OFFSET; // 341

  function loadSold() {
    fetch('/collections/weisse-scheisse-1/products.json?limit=1')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || !data.products.length) {
          el.textContent = BASE;
          return;
        }
        var product = data.products[0];
        var totalOnHand = 0;
        var tracked = false;

        product.variants.forEach(function(v) {
          if (v.inventory_management === 'shopify') {
            tracked = true;
            // inventory_quantity kann negativ sein bei Oversell
            totalOnHand += (v.inventory_quantity || 0);
          }
        });

        if (!tracked || totalOnHand <= 0) {
          el.textContent = BASE;
          return;
        }

        var sold = Math.max(0, TOTAL - totalOnHand);
        var display = Math.max(BASE, sold + OFFSET);
        if (display > TOTAL) display = TOTAL;
        el.textContent = display;
      })
      .catch(function() {
        el.textContent = BASE;
      });
  }

  loadSold();
  setInterval(loadSold, 60000);
})();
